import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import App from './App'
import ProtectedRoute from './components/ProtectedRoute'
import AdminMasterPanel from './pages/AdminMasterPanel'

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/master" element={<ProtectedRoute><AdminMasterPanel /></ProtectedRoute>} />
      <Route path="*" element={<App />} />
      <Route path="/admin/premium-access" element={<Navigate to="/master" replace />} />
    </Routes>
  )
}
